module.exports = __webpack_public_path__ + "static/media/ProFACT_Training_Manual.3780c70d.pdf";